import styled from "@emotion/styled";
import { forwardRef, HTMLAttributes, ReactNode } from "react";

interface Props extends HTMLAttributes<HTMLElement> {
  children: ReactNode;
  ratio?: number;
}

export const DEFAULT_ASPECT_RATIO = 1;

const AspectRatio = forwardRef<HTMLDivElement, Props>(
  (
    { children, ratio = DEFAULT_ASPECT_RATIO, ...elementProps },
    ref
  ): JSX.Element => (
    <OuterWrapper ref={ref} ratio={ratio} {...elementProps}>
      <InnerWrapper>{children}</InnerWrapper>
    </OuterWrapper>
  )
);

AspectRatio.displayName = "AspectRatio";

export default AspectRatio;

const OuterWrapper = styled.div<{
  ratio: number;
}>`
  @supports (aspect-ratio: auto) {
    aspect-ratio: ${({ ratio }) => ratio};
  }

  @supports not (aspect-ratio: auto) {
    padding-bottom: ${({ ratio }) => (1 / ratio) * 100}%;
  }
  position: relative;
`;

const InnerWrapper = styled.div`
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;

  & > * {
    height: 100%;
    width: 100%;
  }
`;
